var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "b-card-header",
            { class: { "sticky-header": _vm.showHeader } },
            [
              _c(
                "b-row",
                { attrs: { "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "mr-auto", attrs: { cols: "auto" } },
                    [
                      _c("h5", { staticClass: "mb-0" }, [
                        _vm._v(_vm._s(_vm.title))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            size: "sm",
                            variant: "info",
                            disabled: _vm.isBusy
                          },
                          on: {
                            click: function($event) {
                              return _vm.openModalCopying()
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "copy" }
                          }),
                          _vm._v("\n            Копировать\n          ")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName:
                                "v-b-toggle.sidebar-fields-location-vacancies",
                              modifiers: {
                                "sidebar-fields-location-vacancies": true
                              }
                            }
                          ],
                          attrs: {
                            id: "table-settings",
                            size: "sm",
                            variant: "warning",
                            disabled: _vm.isBusy
                          }
                        },
                        [_c("font-awesome-icon", { attrs: { icon: "cog" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tooltip",
                        {
                          attrs: {
                            target: "table-settings",
                            triggers: "hover",
                            variant: "warning",
                            noninteractive: ""
                          }
                        },
                        [_vm._v("\n            Строки\n          ")]
                      ),
                      _vm._v(" "),
                      !_vm.showDetails
                        ? _c(
                            "b-button",
                            {
                              attrs: {
                                size: "sm",
                                variant: "success",
                                disabled: _vm.isBusy || _vm.isDisabled
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.onAdd()
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "plus" }
                              }),
                              _vm._v("\n            Добавить\n          ")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showDetails
                        ? _c(
                            "b-button",
                            {
                              staticClass: "text-secondary ml-3 p-0",
                              attrs: { variant: "link" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("close")
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "times", size: "lg" }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.items.length > 0
            ? _c(
                "div",
                [
                  _c("b-table", {
                    ref: "location_vacancies",
                    staticClass: "mb-0 no-borders-table",
                    attrs: {
                      id: "location-vacancies",
                      "thead-class": "d-none",
                      bordered: "",
                      small: "",
                      responsive: "",
                      items: _vm.renderedColumns,
                      fields: _vm.setupColumns
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "cell(row_title)",
                          fn: function(col) {
                            return [
                              col.item.type === "header"
                                ? _c("div", { staticClass: "row-header" }, [
                                    _c("span", { staticClass: "mr-auto" }, [
                                      _vm._v(" " + _vm._s(col.value) + " ")
                                    ])
                                  ])
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "py-1 pl-1 d-flex align-items-center"
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "font-weight-bold mr-auto"
                                        },
                                        [_vm._v(_vm._s(col.value))]
                                      ),
                                      _vm._v(" "),
                                      _vm.allFieldsRequired
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "font-weight-bold text-danger"
                                            },
                                            [_vm._v("*")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      col.item.isJoint && _vm.items.length > 1
                                        ? _c("b-form-checkbox", {
                                            staticClass:
                                              "ml-2 warning-checkbox",
                                            attrs: {
                                              value: col.item.key,
                                              switch: "",
                                              size: "sm"
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.onToggleJoint(
                                                  col.item.key
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.jointFields,
                                              callback: function($$v) {
                                                _vm.jointFields = $$v
                                              },
                                              expression: "jointFields"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                            ]
                          }
                        },
                        {
                          key: "cell()",
                          fn: function(col) {
                            return [
                              _vm.isFieldJoint(col.item.key)
                                ? _c(
                                    "div",
                                    { staticClass: "px-1" },
                                    [
                                      col.item.key === "citizenships"
                                        ? _c(
                                            "div",
                                            [
                                              _c("citizenships-multi-select", {
                                                attrs: {
                                                  value:
                                                    _vm.items[0].citizenships,
                                                  "catalog-items":
                                                    _vm.citizenshipsCatalog,
                                                  "is-disabled": _vm.isDisabled
                                                },
                                                on: {
                                                  "catalog-created":
                                                    _vm.getCatalogs,
                                                  input: function($event) {
                                                    return _vm.updateAllItems(
                                                      "citizenships",
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : col.item.key === "employment"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center"
                                            },
                                            [
                                              _c(
                                                "b-dropdown",
                                                {
                                                  staticClass:
                                                    "w-40 mr-1 text-small",
                                                  attrs: {
                                                    text: _vm.getMultiSelectText(
                                                      _vm.items[0]
                                                        .employment_types,
                                                      _vm.employmentTypesOptions
                                                    ),
                                                    disabled: _vm.isDisabled,
                                                    variant: "outline-primary",
                                                    size: "sm"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "b-dropdown-form",
                                                    [
                                                      _c(
                                                        "b-form-checkbox-group",
                                                        {
                                                          staticClass:
                                                            "text-small",
                                                          attrs: {
                                                            checked:
                                                              _vm.items[0]
                                                                .employment_types,
                                                            options:
                                                              _vm.employmentTypesOptions,
                                                            stacked: ""
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              return _vm.updateAllItems(
                                                                "employment_types",
                                                                $event
                                                              )
                                                            }
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("b-form-textarea", {
                                                staticClass: "w-60 text-small",
                                                attrs: {
                                                  value:
                                                    _vm.items[0].employment,
                                                  disabled: _vm.isDisabled,
                                                  rows: "2",
                                                  placeholder:
                                                    col.item.placeholder
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.updateAllItems(
                                                      "employment",
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : col.item.key ===
                                          "employment_categories"
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "employment-categories-multi-select",
                                                {
                                                  attrs: {
                                                    value:
                                                      _vm.items[0]
                                                        .employment_categories,
                                                    "catalog-items":
                                                      _vm.employmentCategoriesCatalog,
                                                    "is-disabled":
                                                      _vm.isDisabled
                                                  },
                                                  on: {
                                                    "catalog-created":
                                                      _vm.getCatalogs,
                                                    input: function($event) {
                                                      return _vm.updateAllItems(
                                                        "employment_categories",
                                                        $event
                                                      )
                                                    }
                                                  }
                                                }
                                              )
                                            ],
                                            1
                                          )
                                        : col.item.key === "certificates"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center"
                                            },
                                            [
                                              _c(
                                                "driver-license-categories-multi-select",
                                                {
                                                  staticClass: "w-25 mr-1",
                                                  attrs: {
                                                    value:
                                                      _vm.items[0]
                                                        .driver_license_categories,
                                                    "catalog-items":
                                                      _vm.driverLicenseCategoriesCatalog,
                                                    "is-disabled":
                                                      _vm.isDisabled
                                                  },
                                                  on: {
                                                    "catalog-created":
                                                      _vm.getCatalogs,
                                                    input: function($event) {
                                                      return _vm.updateAllItems(
                                                        "driver_license_categories",
                                                        $event
                                                      )
                                                    }
                                                  }
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c("b-form-textarea", {
                                                staticClass: "w-75 text-small",
                                                attrs: {
                                                  value:
                                                    _vm.items[0].certificates,
                                                  disabled: _vm.isDisabled,
                                                  rows: "2",
                                                  placeholder:
                                                    col.item.placeholder
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.updateAllItems(
                                                      "certificates",
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : col.item.key === "shift_hours"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center px-1"
                                            },
                                            [
                                              _c("b-form-input", {
                                                staticClass: "mr-1 w-50",
                                                attrs: {
                                                  type: "time",
                                                  value: _vm.getShiftTime(
                                                    _vm.items[0].shift_hours,
                                                    0
                                                  ),
                                                  disabled: _vm.isDisabled,
                                                  size: "sm"
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.updateShiftTimeJoint(
                                                      0,
                                                      $event
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("b-form-input", {
                                                staticClass: "mr-1 w-50",
                                                attrs: {
                                                  type: "time",
                                                  value: _vm.getShiftTime(
                                                    _vm.items[0].shift_hours,
                                                    1
                                                  ),
                                                  disabled: _vm.isDisabled,
                                                  size: "sm"
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.updateShiftTimeJoint(
                                                      1,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : col.item.key === "schedule"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center"
                                            },
                                            [
                                              _c("b-form-textarea", {
                                                staticClass: "mr-1 text-small",
                                                attrs: {
                                                  value: _vm.items[0].schedule,
                                                  disabled: _vm.isDisabled,
                                                  rows: "1",
                                                  "max-rows": "4",
                                                  placeholder: "График"
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.updateAllItems(
                                                      "schedule",
                                                      $event
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "b-dropdown",
                                                {
                                                  staticClass:
                                                    "w-25 mr-1 text-small",
                                                  attrs: {
                                                    text: _vm.getMultiSelectText(
                                                      _vm.items[0]
                                                        .schedule_time_of_day,
                                                      _vm.shiftOptions
                                                    ),
                                                    disabled: _vm.isDisabled,
                                                    variant: "outline-primary",
                                                    size: "sm"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "b-dropdown-form",
                                                    [
                                                      _c(
                                                        "b-form-checkbox-group",
                                                        {
                                                          staticClass:
                                                            "text-small",
                                                          attrs: {
                                                            checked:
                                                              _vm.items[0]
                                                                .schedule_time_of_day,
                                                            options:
                                                              _vm.shiftOptions,
                                                            stacked: ""
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              return _vm.updateAllItems(
                                                                "schedule_time_of_day",
                                                                $event
                                                              )
                                                            }
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("b-form-textarea", {
                                                staticClass: "text-small",
                                                attrs: {
                                                  value:
                                                    _vm.items[0]
                                                      .night_coefficient,
                                                  disabled: _vm.isDisabled,
                                                  size: "sm",
                                                  rows: "2",
                                                  "max-rows": "6",
                                                  placeholder: "Ночной коэф."
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.updateAllItems(
                                                      "night_coefficient",
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : col.item.type === "input"
                                        ? _c("b-form-textarea", {
                                            staticClass: "text-small",
                                            attrs: {
                                              disabled: _vm.isDisabled,
                                              rows: "2",
                                              "max-rows": "6",
                                              value: _vm.items[0][col.item.key],
                                              placeholder:
                                                col.item.placeholder ||
                                                "Значение для всех вакансий"
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.updateAllItems(
                                                  col.item.key,
                                                  $event
                                                )
                                              }
                                            }
                                          })
                                        : col.item.type === "number"
                                        ? _c("b-form-input", {
                                            staticClass: "text-small",
                                            attrs: {
                                              disabled: _vm.isDisabled,
                                              type: "number",
                                              value: _vm.items[0][col.item.key],
                                              placeholder:
                                                col.item.placeholder ||
                                                "Введите число"
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.updateAllItems(
                                                  col.item.key,
                                                  $event
                                                )
                                              },
                                              keydown: _vm.onlyNumbers
                                            }
                                          })
                                        : col.item.type === "range"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center px-5"
                                            },
                                            [
                                              _c("b-form-input", {
                                                staticClass: "text-small mr-5",
                                                attrs: {
                                                  disabled: _vm.isDisabled,
                                                  type: "number",
                                                  value: _vm.items[0].age_from,
                                                  placeholder: "От"
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.updateAllItems(
                                                      "age_from",
                                                      $event
                                                    )
                                                  },
                                                  keydown: _vm.onlyNumbers
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("b-form-input", {
                                                staticClass: "text-small",
                                                attrs: {
                                                  disabled: _vm.isDisabled,
                                                  type: "number",
                                                  value: _vm.items[0].age_to,
                                                  placeholder: "До"
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.updateAllItems(
                                                      "age_to",
                                                      $event
                                                    )
                                                  },
                                                  keydown: _vm.onlyNumbers
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : col.item.type === "checkbox-input"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center px-3"
                                            },
                                            [
                                              _c("b-form-checkbox", {
                                                staticClass: "mr-2 mb-0",
                                                attrs: {
                                                  checked:
                                                    _vm.items[0][col.item.key],
                                                  disabled: _vm.isDisabled
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.updateAllItems(
                                                      col.item.key,
                                                      $event
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("b-form-textarea", {
                                                staticClass: "text-small",
                                                attrs: {
                                                  value:
                                                    _vm.items[0][
                                                      col.item.commentKey
                                                    ],
                                                  disabled: _vm.isDisabled,
                                                  rows: "2",
                                                  "max-rows": "6",
                                                  placeholder:
                                                    col.item.placeholder ||
                                                    "Добавьте комментарий"
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.updateAllItems(
                                                      col.item.commentKey,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : col.item.type === "multiselect"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center justify-content-center"
                                            },
                                            [
                                              _c(
                                                "b-dropdown",
                                                {
                                                  staticClass:
                                                    "w-75 text-small",
                                                  attrs: {
                                                    text: _vm.getMultiSelectText(
                                                      _vm.items[0][
                                                        col.item.key
                                                      ],
                                                      _vm.getOptions(
                                                        col.item.optionsKey
                                                      )
                                                    ),
                                                    disabled: _vm.isDisabled,
                                                    variant: "outline-primary",
                                                    size: "sm"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "b-dropdown-form",
                                                    [
                                                      _c(
                                                        "b-form-checkbox-group",
                                                        {
                                                          staticClass:
                                                            "text-small",
                                                          attrs: {
                                                            checked:
                                                              _vm.items[0][
                                                                col.item.key
                                                              ],
                                                            options: _vm.getOptions(
                                                              col.item
                                                                .optionsKey
                                                            ),
                                                            stacked: ""
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              return _vm.updateAllItems(
                                                                col.item.key,
                                                                $event
                                                              )
                                                            }
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "px-1 min-w-327" },
                                    [
                                      col.item.key === "vacancy"
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "b-button-group",
                                                { staticClass: "d-flex" },
                                                [
                                                  _c("vacancy-select", {
                                                    ref: "vacancy_select",
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      id:
                                                        _vm.items[col.field.key]
                                                          .vacancy_id,
                                                      "is-disabled":
                                                        _vm.isDisabled
                                                    },
                                                    on: {
                                                      onSelect: function(
                                                        $event
                                                      ) {
                                                        return _vm.onSelectVacancy(
                                                          $event,
                                                          col.field.key
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  !_vm.showDetails
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          staticClass:
                                                            "flex-grow-0",
                                                          attrs: {
                                                            disabled:
                                                              _vm.isDisabled,
                                                            variant: "danger",
                                                            size: "sm"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.onRemove(
                                                                col.field.key
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon: "trash"
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : col.item.key === "citizenships"
                                        ? _c(
                                            "div",
                                            [
                                              _c("citizenships-multi-select", {
                                                attrs: {
                                                  "catalog-items":
                                                    _vm.citizenshipsCatalog,
                                                  "is-disabled": _vm.isDisabled
                                                },
                                                on: {
                                                  "catalog-created":
                                                    _vm.getCatalogs
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[col.field.key]
                                                      .citizenships,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[col.field.key],
                                                      "citizenships",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "items[col.field.key].citizenships"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : col.item.key ===
                                          "employment_categories"
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "employment-categories-multi-select",
                                                {
                                                  attrs: {
                                                    "catalog-items":
                                                      _vm.employmentCategoriesCatalog,
                                                    "is-disabled":
                                                      _vm.isDisabled
                                                  },
                                                  on: {
                                                    "catalog-created":
                                                      _vm.getCatalogs
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.items[col.field.key]
                                                        .employment_categories,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.items[
                                                          col.field.key
                                                        ],
                                                        "employment_categories",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "items[col.field.key].employment_categories"
                                                  }
                                                }
                                              )
                                            ],
                                            1
                                          )
                                        : col.item.key === "employment"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center"
                                            },
                                            [
                                              _c(
                                                "b-dropdown",
                                                {
                                                  staticClass:
                                                    "w-40 mr-1 text-small",
                                                  attrs: {
                                                    text: _vm.getMultiSelectText(
                                                      _vm.items[col.field.key]
                                                        .employment_types,
                                                      _vm.employmentTypesOptions
                                                    ),
                                                    disabled: _vm.isDisabled,
                                                    variant: "outline-primary",
                                                    size: "sm"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "b-dropdown-form",
                                                    [
                                                      _c(
                                                        "b-form-checkbox-group",
                                                        {
                                                          staticClass:
                                                            "text-small",
                                                          attrs: {
                                                            options:
                                                              _vm.employmentTypesOptions,
                                                            stacked: ""
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.items[
                                                                col.field.key
                                                              ]
                                                                .employment_types,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.items[
                                                                  col.field.key
                                                                ],
                                                                "employment_types",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "items[col.field.key].employment_types"
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("b-form-textarea", {
                                                staticClass: "w-60 text-small",
                                                attrs: {
                                                  disabled: _vm.isDisabled,
                                                  rows: "2",
                                                  placeholder:
                                                    col.item.placeholder
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[col.field.key]
                                                      .employment,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[col.field.key],
                                                      "employment",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "items[col.field.key].employment"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : col.item.key === "certificates"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center flex-wrap"
                                            },
                                            [
                                              _c(
                                                "driver-license-categories-multi-select",
                                                {
                                                  staticClass: "mr-1",
                                                  staticStyle: {
                                                    flex: "1 1 50%"
                                                  },
                                                  attrs: {
                                                    "catalog-items":
                                                      _vm.driverLicenseCategoriesCatalog,
                                                    "is-disabled":
                                                      _vm.isDisabled
                                                  },
                                                  on: {
                                                    "catalog-created":
                                                      _vm.getCatalogs
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.items[col.field.key]
                                                        .driver_license_categories,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.items[
                                                          col.field.key
                                                        ],
                                                        "driver_license_categories",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "items[col.field.key].driver_license_categories"
                                                  }
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c("b-form-textarea", {
                                                staticClass: "text-small",
                                                staticStyle: {
                                                  flex: "1 1 40%"
                                                },
                                                attrs: {
                                                  disabled: _vm.isDisabled,
                                                  rows: "2",
                                                  placeholder:
                                                    col.item.placeholder
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[col.field.key]
                                                      .certificates,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[col.field.key],
                                                      "certificates",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "items[col.field.key].certificates"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : col.item.key === "shift_hours"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center justify-content-center w-100"
                                            },
                                            [
                                              _c("b-form-input", {
                                                staticClass: "mr-1 text-center",
                                                staticStyle: {
                                                  "max-width": "85px"
                                                },
                                                attrs: {
                                                  type: "time",
                                                  value: _vm.getShiftTime(
                                                    _vm.items[col.field.key]
                                                      .shift_hours,
                                                    0
                                                  ),
                                                  disabled: _vm.isDisabled,
                                                  size: "sm"
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.updateShiftTimeSeparated(
                                                      col.field.key,
                                                      0,
                                                      $event
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("b-form-input", {
                                                staticClass: "text-center",
                                                staticStyle: {
                                                  "max-width": "85px"
                                                },
                                                attrs: {
                                                  type: "time",
                                                  value: _vm.getShiftTime(
                                                    _vm.items[col.field.key]
                                                      .shift_hours,
                                                    1
                                                  ),
                                                  disabled: _vm.isDisabled,
                                                  size: "sm"
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.updateShiftTimeSeparated(
                                                      col.field.key,
                                                      1,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : col.item.key === "schedule"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center justify-content-center"
                                            },
                                            [
                                              _c("b-form-textarea", {
                                                staticClass: "mr-1 text-small",
                                                attrs: {
                                                  disabled: _vm.isDisabled,
                                                  size: "sm",
                                                  rows: "2",
                                                  "max-rows": "6",
                                                  placeholder: "Укажите график"
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[col.field.key]
                                                      .schedule,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[col.field.key],
                                                      "schedule",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "items[col.field.key].schedule"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "b-dropdown",
                                                {
                                                  staticClass:
                                                    "w-33 mr-1 text-small",
                                                  attrs: {
                                                    text: _vm.getMultiSelectText(
                                                      _vm.items[col.field.key]
                                                        .schedule_time_of_day,
                                                      _vm.shiftOptions
                                                    ),
                                                    disabled: _vm.isDisabled,
                                                    variant: "outline-primary",
                                                    size: "sm"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "b-dropdown-form",
                                                    [
                                                      _c(
                                                        "b-form-checkbox-group",
                                                        {
                                                          staticClass:
                                                            "text-small",
                                                          attrs: {
                                                            options:
                                                              _vm.shiftOptions,
                                                            stacked: ""
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.items[
                                                                col.field.key
                                                              ]
                                                                .schedule_time_of_day,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.items[
                                                                  col.field.key
                                                                ],
                                                                "schedule_time_of_day",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "items[col.field.key].schedule_time_of_day"
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("b-form-textarea", {
                                                staticClass: "text-small",
                                                attrs: {
                                                  disabled: _vm.isDisabled,
                                                  size: "sm",
                                                  rows: "2",
                                                  "max-rows": "6",
                                                  placeholder: "Ночной коэф."
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[col.field.key]
                                                      .night_coefficient,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[col.field.key],
                                                      "night_coefficient",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "items[col.field.key].night_coefficient"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : col.item.type === "input"
                                        ? _c("b-form-textarea", {
                                            attrs: {
                                              disabled: _vm.isDisabled,
                                              size: "sm",
                                              rows: "2",
                                              "max-rows": "6",
                                              placeholder: col.item.placeholder
                                            },
                                            model: {
                                              value:
                                                _vm.items[col.field.key][
                                                  col.item.key
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.items[col.field.key],
                                                  col.item.key,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "items[col.field.key][col.item.key]"
                                            }
                                          })
                                        : col.item.type === "number"
                                        ? _c("b-form-input", {
                                            attrs: {
                                              disabled: _vm.isDisabled,
                                              min: "0",
                                              type: "number",
                                              size: "sm",
                                              placeholder: col.item.placeholder
                                            },
                                            on: { keydown: _vm.onlyNumbers },
                                            model: {
                                              value:
                                                _vm.items[col.field.key][
                                                  col.item.key
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.items[col.field.key],
                                                  col.item.key,
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression:
                                                "items[col.field.key][col.item.key]"
                                            }
                                          })
                                        : col.item.type === "range"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-center"
                                            },
                                            [
                                              _c("b-form-input", {
                                                staticClass: "mr-1 w-25",
                                                attrs: {
                                                  disabled: _vm.isDisabled,
                                                  type: "number",
                                                  min: "0",
                                                  size: "sm",
                                                  placeholder: "От"
                                                },
                                                on: {
                                                  keydown: _vm.onlyNumbers
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[col.field.key]
                                                      .age_from,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[col.field.key],
                                                      "age_from",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression:
                                                    "items[col.field.key].age_from"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("b-form-input", {
                                                staticClass: "w-25",
                                                attrs: {
                                                  disabled: _vm.isDisabled,
                                                  type: "number",
                                                  min: "0",
                                                  size: "sm",
                                                  placeholder: "До"
                                                },
                                                on: {
                                                  keydown: _vm.onlyNumbers
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[col.field.key]
                                                      .age_to,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[col.field.key],
                                                      "age_to",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression:
                                                    "items[col.field.key].age_to"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : col.item.type === "checkbox-input"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center px-3"
                                            },
                                            [
                                              _c("b-form-checkbox", {
                                                staticClass: "mr-2 mb-0",
                                                attrs: {
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[col.field.key][
                                                      col.item.key
                                                    ],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[col.field.key],
                                                      col.item.key,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "items[col.field.key][col.item.key]"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("b-form-textarea", {
                                                staticClass: "text-small",
                                                attrs: {
                                                  disabled: _vm.isDisabled,
                                                  rows: "2",
                                                  "max-rows": "6",
                                                  placeholder:
                                                    col.item.placeholder ||
                                                    "Комментарий"
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[col.field.key][
                                                      col.item.commentKey
                                                    ],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[col.field.key],
                                                      col.item.commentKey,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "items[col.field.key][col.item.commentKey]"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : col.item.type === "multiselect"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center justify-content-center"
                                            },
                                            [
                                              _c(
                                                "b-dropdown",
                                                {
                                                  staticClass:
                                                    "w-25 text-small",
                                                  attrs: {
                                                    text: _vm.getMultiSelectText(
                                                      _vm.items[col.field.key][
                                                        col.item.key
                                                      ],
                                                      _vm.getOptions(
                                                        col.item.optionsKey
                                                      )
                                                    ),
                                                    disabled: _vm.isDisabled,
                                                    variant: "outline-primary",
                                                    size: "sm"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "b-dropdown-form",
                                                    [
                                                      _c(
                                                        "b-form-checkbox-group",
                                                        {
                                                          staticClass:
                                                            "text-small",
                                                          attrs: {
                                                            options: _vm.getOptions(
                                                              col.item
                                                                .optionsKey
                                                            ),
                                                            stacked: ""
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.items[
                                                                col.field.key
                                                              ][col.item.key],
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.items[
                                                                  col.field.key
                                                                ],
                                                                col.item.key,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "items[col.field.key][col.item.key]"
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3370960148
                    )
                  })
                ],
                1
              )
            : _vm.isBusy
            ? _c(
                "div",
                { staticClass: "text-center text-success my-2" },
                [
                  _c("b-spinner", { staticClass: "align-middle" }),
                  _vm._v(" "),
                  _c("strong", [_vm._v("Загрузка")])
                ],
                1
              )
            : _c("div", { staticClass: "empty-placeholder" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("message.common.emptyTable")) +
                    "\n    "
                )
              ]),
          _vm._v(" "),
          !_vm.showDetails
            ? _c(
                "b-card-footer",
                { attrs: { "footer-bg-variant": "light" } },
                [
                  _c(
                    "b-row",
                    { attrs: { "align-h": "between", "align-v": "center" } },
                    [
                      _c(
                        "b-col",
                        { staticClass: "mr-auto", attrs: { cols: "auto" } },
                        [
                          _vm._v("\n          Всего записей: "),
                          _c("b", [_vm._v(_vm._s(_vm.items.length))])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modal_vacancy_copying",
          attrs: {
            id: "modal-vacancy-copying",
            title: "Текст вакансий объекта",
            size: "xl",
            scrollable: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var cancel = ref.cancel
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "secondary" },
                      on: {
                        click: function($event) {
                          return _vm.closeModalCopying()
                        }
                      }
                    },
                    [_vm._v("\n        Назад\n      ")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.showModalCopying,
            callback: function($$v) {
              _vm.showModalCopying = $$v
            },
            expression: "showModalCopying"
          }
        },
        [
          _vm.items.length > 0
            ? _c(
                "b-card",
                { attrs: { "no-body": "" } },
                [
                  _c(
                    "b-tabs",
                    { attrs: { pills: "", card: "", vertical: "" } },
                    _vm._l(_vm.items, function(item, index) {
                      return _c(
                        "b-tab",
                        {
                          key: index,
                          attrs: { title: _vm.vacancyModalTabTitles[index] }
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "mb-2" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "ml-auto",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "outline-primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.copyToClipboard(index)
                                        }
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "mr-1",
                                        attrs: { icon: "copy" }
                                      }),
                                      _vm._v(
                                        "\n                Скопировать текст\n              "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-form-textarea", {
                            staticClass: "p-3 bg-light",
                            attrs: {
                              id: "vacancy-text-" + index,
                              "no-resize": "",
                              readonly: "",
                              rows: "45",
                              value: _vm.generateVacancyText(item)
                            }
                          })
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : _c("div", { staticClass: "text-center text-muted py-4" }, [
                _vm._v("\n      Нет добавленных вакансий.\n    ")
              ])
        ],
        1
      ),
      _vm._v(" "),
      _c("dynamic-tables", {
        attrs: {
          "storage-key": "locationVacancies_columns",
          "sidebar-fields": "sidebar-fields-location-vacancies",
          "fields-model": _vm.columns,
          fieldKey: "vacancy"
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.columns = $event
          },
          "update:fields-model": function($event) {
            _vm.columns = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-80c63bda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80c63bda","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Locations/LocationVacancies.vue
// module id = null
// module chunks = 